import { render } from "./customStyle.vue?vue&type=template&id=0740a586"
import script from "./customStyle.vue?vue&type=script&lang=js"
export * from "./customStyle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__